import { downloadFile, sleep } from '@mi-front/core';
import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export function DownloadExportBtn({ fetchUrl }: { fetchUrl: () => Promise<string> }) {
  const [fetching, setFetching] = useState(false);
  const { $t } = useIntl();

  return (
    <Button
      color="info"
      size="small"
      disabled={fetching}
      onClick={() => {
        fetchUrl().then(async (url) => {
          downloadFile(url, false);
          await sleep(1000);
          setFetching(false);
        });

        setFetching(true);
      }}
      startIcon={<DownloadIcon />}
      variant="outlined"
    >
      {$t({
        id: 'audit.aod.actions.downloadExport',
        defaultMessage: 'Descargar export',
      })}
    </Button>
  );
}
